<app-dialog-wrapper
    heading="common.reassign-request-dialog.title"
    description="common.reassign-request-dialog.description"
    confirmLabel="common.general.confirm"
    cancelLabel="common.general.cancel"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <sh-team-picker
        label="{{ 'nam.request-information.siemens-team' | translate }}"
        [formControl]="selectedTeam"
    ></sh-team-picker>
    <sh-user-picker
        label="{{ 'common.request-tables.assignee' | translate }}"
        [formControl]="selectedUser"
        [roles]="[rolesEnum.TASK_OWNER]"
    ></sh-user-picker>
</app-dialog-wrapper>
